// extracted by mini-css-extract-plugin
export default {"messageInputContainer":"MessageInput_messageInputContainer__jXk-G","form":"MessageInput_form__Nmehz","textArea":"MessageInput_textArea__JxEj7","icon":"MessageInput_icon__zuk9J"};